import React, { useCallback, useEffect } from "react";
import styles from "./SuitableForHsk.module.sass";
import TableComponent from "../../../../../components/TableComponent";
import { BiPlus } from "react-icons/bi";
import useState from "react-usestateref";
import { useSelector } from "react-redux";
import Modal from "../../../../../components/Modal";

const columns = [
  {
    header: "Deck name",
    accessor: "deckName",
  },
  {
    header: "Level",
    accessor: "level",
  },
  {
    header: "Actions",
    accessor: "actions",
  },
];

const SuitableForHsk = ({ suitableForHskSelected, setSuitableForHskSelected, isEdit }) => {
  const { decks } = useSelector((state) => state);

  const [visibleModal, setVisibleModal] = useState(false);
  const [decksTable, setDecksTable] = useState([]);

  const [deckTable, setDeckTable, deckTableRef] = useState([]);

  const handleDeleteDeckTableID = useCallback((id) => {
    setDeckTable((prev) => {
      const filtered = prev?.filter((c) => c._id !== id) ?? [];
      setSuitableForHskSelected(filtered?.length ? filtered?.map((c) => c?._id) : []);
      return filtered;
    });
  }, [setDeckTable, setSuitableForHskSelected]);

  const handleParseDataDeck = useCallback((deck) => {
    return {
      deckName: {
        data: deck?.title,
        dataComponent: deck?.title,
      },
      level: {
        data: deck?.level || "-",
        dataComponent: deck?.level || "-",
      },
      _id: deck?._id,
      actions: {
        data: "actions",
        dataComponent: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <button className={styles.linkAction} onClick={() => window.open(`/deck/edit/${deck?._id}`, "_blank")}>
              View
            </button>
            <button className={styles.linkActionDanger} onClick={() => handleDeleteDeckTableID(deck?._id)}>
              Delete
            </button>
          </div>
        ),
      },
    };
  }, [handleDeleteDeckTableID]);

  const handleAddDeckTableID = useCallback((deck) => {
    if (!deckTableRef.current?.find((c) => c._id === deck?._id)) {
      const _deckTable = [...deckTableRef.current, handleParseDataDeck(deck)];
      setDeckTable(_deckTable);
      setSuitableForHskSelected(_deckTable?.map((c) => c?._id));
      setVisibleModal(false);
    }
  }, [deckTableRef, handleParseDataDeck, setDeckTable, setSuitableForHskSelected, setVisibleModal]);

  useEffect(() => {
    if (isEdit && suitableForHskSelected && deckTable.length === 0) {
      const parsedDecks = suitableForHskSelected?.map((c) => handleParseDataDeck(c)) ?? [];
      if (parsedDecks.length > 0) {
        setDeckTable(parsedDecks);
      }
    }
  }, [deckTable.length, handleParseDataDeck, isEdit, setDeckTable, suitableForHskSelected]);

  useEffect(() => {
    if (decks?.value) {
      setDecksTable(
        decks?.value?.map((deck) => {
          return {
            deckName: {
              data: deck?.title,
              dataComponent: deck?.title,
            },
            level: {
              data: deck?.level || "-",
              dataComponent: deck?.level || "-",
            },
            _id: deck?._id,
            actions: {
              data: "actions",
              dataComponent: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button className={styles.linkAction} onClick={() => handleAddDeckTableID(deck)} title="Add">
                    <BiPlus size="20" />
                  </button>
                </div>
              ),
            },
          };
        })
      );
    }
  }, [decks, handleAddDeckTableID]);

  const handleShowModalAddDeck = () => {
    setVisibleModal(true);
  };

  return (
    <div>
      <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <div className={styles.modalContent}>
          <TableComponent
            className={styles.decksModal}
            tableClassName={styles.decksTable}
            title="decks"
            data={decksTable}
            columns={columns}
            embedded
            isCardStyle={false}
          />
        </div>
      </Modal>
      <TableComponent
        data={deckTable}
        columns={columns}
        isButton={true}
        buttonText="Add Deck"
        buttonIcon={<BiPlus size="24" />}
        buttonHandler={handleShowModalAddDeck}
        title="Suitable for HSK"
      />
    </div>
  );
};

export default SuitableForHsk;
